import * as qs from "qs"

const useUrlParams = () => {
    const search = window.location.search
    return qs.parse(search, { ignoreQueryPrefix: true })
}

export default useUrlParams
